import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OperativeInfo } from 'src/app/domain-model/operative-info.class';
import { OperativesService } from 'src/app/operatives/services/operatives.service';
import { ListDataService } from 'src/app/services/list-data.service';
import { IRiskInfo } from 'src/app/message-models/risk-info.interface';
import { IJobTitleInfo } from 'src/app/message-models/job-title.interface';
import { IJobLevelInfo } from 'src/app/message-models/job-level.interface';
import { ObservationsService } from '../../../observations/services/observations.service';
import { IObservation } from '../../../message-models/observation.interface';
import { OperativeDocumentService } from '../../services/operative-document.service';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentService } from '../../../documents/services/document.service';
import { TrainingRecordModalService } from '../../../training-records/services/training-record-modal.service';
import { TrainingRecordsService } from '../../../training-records/services/training-records.service';
import { ITrainingType } from '../../../message-models/training-record-type.interface';
import { ObservationModalService } from '../../../observations/services/observation-modal.service';
import { Observation, ObservationType, ObservationTypeString } from '../../../domain-model/observation.class';
import { ITrainingRecord } from '../../../message-models/training-record.interface';
import { TrainingRecord } from '../../../domain-model/training-record.class';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ITrainingRecordSummary } from '../../../message-models/training-record-summary.interface';
import { EngagementModalService } from '../../services/engagement-modal.service';
import { CompanyEngagementHistory } from '../../../message-models/company-engagement-history.class';
import { ICompanyEngagementHistory } from '../../../message-models/company-engagement-history.interface';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { RiskHelpModalService } from '../../../services/risk-help-modal.service';
import { IRiskMatrixEntry } from '../../../message-models/risk-matrix-entry.interface';
import { ExtendedJobLevel } from '../../../message-models/extended-job-level.class';
import { JobLevelInfo } from '../../../message-models/job-level.class';
import { ExtendedRiskInfo } from '../../../message-models/extended-risk-info.class';
import { RiskInfo } from '../../../message-models/risk-info.class';
import { DetailContainerComponent } from '../../../common/components/detail-container/detail-container.component';
import { OperativeModalService } from '../../services/operative-modal.service';
import { OurUserService } from '../../../users/services/user.service';
import { IAllowedOperations, IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { BehaviorSubject, Subscription } from 'rxjs';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { IOperative } from '../../../message-models/operative.interface';
import { UntypedFormControl, Validators } from '@angular/forms';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { TrainingRecordDocumentService } from 'src/app/training-records/services/training-record-document.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { TrainingTypeService } from '../../../training-records/services/training-type.service';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { ElectricalWorkType } from '../../../message-models/electrical-work-type';
import { IEmploymentStatus } from '../../../message-models/employment-status.interface';
import { DegreeOfSupervisionString } from '../../../message-models/risk-matrix-level.enum';
import { JobTitleInfo } from '../../../message-models/job-title.class';
import { IOperativeTypeInfo } from 'src/app/message-models/operative-type.interface';
import { OperativeTypeInfo } from '../../../message-models/operative-type.class';
import { ObservationDocumentService } from '../../../observations/services/observation-document.service';
import { CompanyJobRoleService } from '../../../setting/job-role/services/company-job-role.service';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { BusinessUnitInfo } from '../../../message-models/business-unit.class';
import { CompanyJobTitle } from '../../../message-models/company-job-title.class';

@Component({
  selector: 'app-operative-details',
  templateUrl: './operative-details.component.html',
  styleUrls: ['./operative-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OperativeDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('opDetailsContainerComponent') opDetailsContainerComponent: DetailContainerComponent;
  @ViewChild('opRiskContainer') opRiskContainer: DetailContainerComponent;

  operativeDocuments: IDocumentSummaryInfo[] = [];
  CONSTANTS: typeof consts = consts;
  selectedTrainingRecordId: string | '00000000-0000-0000-0000-000000000000';
  selectedDocumentId: string | '00000000-0000-0000-0000-000000000000';
  savedObservationId: string | '00000000-0000-0000-0000-000000000000';
  operative: OperativeInfo = new OperativeInfo(null);
  operativeTrainingRecords: ITrainingRecordSummary[] = [];
  operativeObservationsSummary: Array<IObservationSummary>;
  observationType: typeof ObservationType = ObservationType;

  allBusinessUnits: IBusinessUnitInfo[];
  selectedBusinessUnitId: string;
  businessUnitsLoaded = false;
  businessUnitHelpText: string;

  allOperativeTypes: IOperativeTypeInfo[];
  selectedOperativeTypeId: string;
  operativeTypesLoaded = false;

  allJobTitles: IJobTitleInfo[] = [];
  filteredJobTitles: IJobTitleInfo[];
  selectedJobTitleId: string;
  jobTitlesLoaded = false;
  showJobTitleUpdate: boolean;

  allCompanyJobTitles: ICompanyJobTitle[] = [];
  selectedCompanyJobTitleId: string;
  companyJobTitlesLoaded = false;

  allJobLevels: ExtendedJobLevel[] = [];
  filteredJobLevels: ExtendedJobLevel[] = [];
  selectedJobLevelId: string;
  jobLevelsLoaded = false;
  showJobLevelUpdate: boolean;

  allRisks: ExtendedRiskInfo[] = [];
  filteredRisks: ExtendedRiskInfo[] = [];
  selectedRiskId: string;
  risksLoaded = false;
  showRiskUpdate: boolean;


  allEmploymentStatuses: IEmploymentStatus[] = [];
  selectedEmploymentStatusId: string;
  employmentStatusesLoaded = false;

  riskMatrix: IRiskMatrixEntry[];
  riskMatrixLoaded = false;

  operativeId: string;
  operativeMaxDate: Date;
  operativeMinDate: Date;
  allListsLoaded = false;

  isNewOperative: boolean;
  private originalOperative: OperativeInfo;
  public editingOperativeDetails: boolean;
  public editingCurrentEngagement: boolean;
  savingOperativeDetails: boolean = false;
  savingEngagementDetails: boolean = false;
  addingOperativeDocuments: boolean = false;
  addingObservationDocuments: boolean = false;
  observationsLoading: boolean = false;
  updatingTrainingRecord: boolean = false;
  trainingRecordTypes: ITrainingType[] = [];
  saveAttempted: boolean = false;
  engagements: CompanyEngagementHistory[] = [];
  public loggedInUser: IUserInfo;
  public companyId: string = consts.emptyGuid;
  public operativeUpdateOperations: IAllowedOperations = {} as IAllowedOperations;
  email: UntypedFormControl;
  loggedInUserSubscription: Subscription;
  isQsRole: boolean = false;
  isNonElectricalJobRole: boolean;
  originalEngagementRole: CompanyEngagementHistory = new CompanyEngagementHistory({} as ICompanyEngagementHistory);
  tempEngagementRole: CompanyEngagementHistory = new CompanyEngagementHistory({} as ICompanyEngagementHistory);
  showRoleBadge: boolean = true;

  loadCurrentRole = new BehaviorSubject(false);
  loadCurrentRoleSubscription: Subscription;
  loadingCurrentEngagement: boolean = true;
  totalCPDHours: number;



  defaultJobJevelId: string;
  constructor(private route: ActivatedRoute,
    private operativesService: OperativesService,
    private listDataService: ListDataService,
    private observationsService: ObservationsService,
    private operativeDocumentService: OperativeDocumentService,
    private observationDocumentService: ObservationDocumentService,
    private trainingRecordsService: TrainingRecordsService,
    private confirmProcessService: EcaConfirmProcessService,
    private documentService: DocumentService,
    private trainingRecordModalService: TrainingRecordModalService,
    private documentModalService: DocumentModalService,
    private observationModalService: ObservationModalService,
    private breadcrumbService: BreadcrumbService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private engagementModalService: EngagementModalService,
    private riskHelpModalService: RiskHelpModalService,
    private operativeModalService: OperativeModalService,
    private userService: OurUserService,
    private errorHandlingService: ErrorHandlingService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private trainingRecordDocumentService: TrainingRecordDocumentService,
    private alertsService: AlertsService,
    private trainingTypeService: TrainingTypeService,
    private helpService: HelpModalService,
    private companyJobRoleService: CompanyJobRoleService,
  ) {
  }

  ngOnInit(): void {
    this.operativeId = this.route.snapshot.params.operativeId;
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser.companyId;
      if (this.loggedInUser?.operativeOperations?.canUpdate) {
        this.operativeUpdateOperations = {
          canInsert: true,
          canUpdate: true,
          canRetrieve: true,
          canDelete: true
        } as IAllowedOperations;
      } else {
        this.operativeUpdateOperations = {} as IAllowedOperations;
      }

      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.loggedInUser = user;
        this.companyId = this.loggedInUser?.companyId;

        if (this.loggedInUser?.operativeOperations?.canUpdate) {
          this.operativeUpdateOperations = {
            canInsert: true,
            canUpdate: true,
            canRetrieve: true,
            canDelete: true
          } as IAllowedOperations;
        } else {
          this.operativeUpdateOperations = {} as IAllowedOperations;
        }

        if (this.companyId !== consts.emptyGuid && this.companyId !== undefined) {
          this.initLists();
        }
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
        // this.router.navigateByUrl('/dashboard');
      });
    });
  }

  initLists() {
    this.listDataService.getBusinessUnitsForCompany(this.companyId).subscribe(types => {
      this.allBusinessUnits = types;
      //this.selectedBusinessUnit = this.allBusinessUnits.find(x => x.id === this.operative.currentBusinessUnitId);
      this.businessUnitsLoaded = true;
      this.businessUnitHelpText = this.allBusinessUnits?.length < 1 ? "You have no Business Units defined. This field is optional but if you wish to create some business units then please go to the Business Units tab on the settings page." : "Choose the Business Unit that best suits the Operatives current role.";
      //this.initOperative();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.listDataService.getAllOperativeTypes().subscribe(types => {
      this.allOperativeTypes = types;
      //this.selectedOperativeType = this.allOperativeTypes.find(x => x.id === this.operative.currentOperativeTypeId);
      this.operativeTypesLoaded = true;
      this.initOperative();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.listDataService.getAllJobTitles().subscribe(titles => {
      this.allJobTitles = titles;
      //this.filteredJobTitles = this.allJobTitles.filter(f => f.operativeTypeId == this.operative.currentOperativeTypeId);
      //this.selectedJobTitle = this.filteredJobTitles.find(x => x.id === this.operative.currentJobTitleId);
      this.jobTitlesLoaded = true;
      this.initOperative();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.listDataService.getAllJobLevels().subscribe(jobLevelsResult => {
      jobLevelsResult.forEach(l => {
        this.allJobLevels.push(new ExtendedJobLevel(l));
      })
      //if (this.isNonElectricalJobRole) {
      //  this.filteredJobLevels = this.allJobLevels.filter(f => f.index === 0);
      //}
      //else {
      //  this.filteredJobLevels = this.allJobLevels.filter(f => f.operativeTypeId == this.operative.currentOperativeTypeId);
      //}

      //this.selectedJobLevel = this.filteredJobLevels.find(x => x.id === this.operative.currentJobLevelId);
      this.jobLevelsLoaded = true;
      this.initOperative();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.listDataService.getAllRisks().subscribe(result => {
      result.forEach(r => {
        this.allRisks.push(new ExtendedRiskInfo(r));
      })
      //if (this.isNonElectricalJobRole) {
      //  this.filteredRisks = this.allRisks.filter(f => f.index === 0);
      //}
      //else {
      //  this.filteredRisks = this.allRisks.filter(f => f.operativeTypeId == this.operative.currentOperativeTypeId);
      //}
      //this.selectedRisk = this.filteredRisks.find(x => x.id === this.operative.currentRiskId);
      this.risksLoaded = true;
      this.initOperative();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.listDataService.getAllEmploymentStatuses().subscribe(employmentStatuses => {
      this.allEmploymentStatuses = employmentStatuses;
      this.employmentStatusesLoaded = true;
      this.initOperative();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    //if (this.operative.currentOperativeTypeId == "4eff2451-6793-4590-82c1-fc189dc47859") {
    //  this.companyJobRoleService.getCompanyJobTitlesByCompanyId(this.companyId).subscribe(listResut => {
    //    this.allCompanyJobTitles = listResut;
    //    this.selectedCompanyJobTitle = this.allCompanyJobTitles.find(x => x.id === this.operative.currentJobTitleId);
    //    this.initOperative();
    //  });
    //}
    this.companyJobRoleService.getCompanyJobTitlesByCompanyId(this.companyId).subscribe(listResut => {
      this.allCompanyJobTitles = listResut;
      //this.selectedCompanyJobTitle = this.allCompanyJobTitles.find(x => x.id === this.operative.currentJobTitleId);
      this.companyJobTitlesLoaded = true;
      this.initOperative();
    });
  }

  validateEmail(email) {
    this.email = new UntypedFormControl(email,
      [Validators.email, Validators.pattern('^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')]);
    if (this.editingOperativeDetails) {
      return this.email.valid;
    } else {
      return true;
    }
  }

  disableDatesPriorSelected(date: IDateTimeWithZone) {
    let selectedDate = new Date(date.dateTime);
    this.operativeMinDate = new Date(selectedDate.setDate(selectedDate.getDate() + 1));
  }

  disableDatesPostSelected(date: IDateTimeWithZone) {
    let selectedDate = new Date(date.dateTime);
    this.operativeMaxDate = new Date(selectedDate.setDate(selectedDate.getDate() - 1));
  }

  initOperative() {
    this.allListsLoaded = this.checkLists();
    if (this.allListsLoaded) {
      this.getTrainingTypesForCompany();
      if (this.operativeId !== 'create') {
        //   this.reloadRoleSettings(true);
        //} else {
        this.loadOperative();
        //this.reloadRoleSettings();
      }
    }
  }

  checkLists(): boolean {
    var result = this.operativeTypesLoaded && this.jobTitlesLoaded && this.jobLevelsLoaded && this.risksLoaded && this.employmentStatusesLoaded && this.businessUnitsLoaded && this.companyJobTitlesLoaded
    return result;
  }

  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
    this.loadCurrentRoleSubscription.unsubscribe();
  }

  private populateBreadcrumbs(isNewOperative: boolean = false, operative?: any) {
    if (isNewOperative) {
      const operativeBreadCrumbs = new Array<IBreadcrumb>();
      operativeBreadCrumbs.push({ label: 'Operatives', iconName: 'users', routeLink: `operatives` } as IBreadcrumb);
      operativeBreadCrumbs.push({
        label: operative.getFullName(),
        iconName: 'user',
        routeLink: `operative/${this.operative.id}`
      } as IBreadcrumb);
      this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
    }
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({ label: 'Operatives', iconName: 'users', routeLink: `operatives` } as IBreadcrumb);
    operativeBreadCrumbs.push({
      label: this.operative.getFullName(),
      iconName: 'user',
      routeLink: `operative/${this.operative.id}`
    } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  private getOperativeById() {
    this.operative = new OperativeInfo({} as IOperative);
    this.operativesService.getOperativeById(this.operativeId, true).subscribe(operative => {
      this.operative = new OperativeInfo(operative);
      this.editingCurrentEngagement = false;
      this.savingEngagementDetails = false;
      this.setCurrentRoleIfOperativeIsLoaded(true);
      this.disableDatesPriorSelected(this.operative?.latestEngagementFrom);
      this.operative.populateRiskMatrixLevel(this.riskMatrix);
      this.populateBreadcrumbs();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
        this.router.navigateByUrl('/dashboard');
      });
    });
  }

  getCurrentRoleIfOperativeIsLoaded() {
    return this.loadCurrentRole.asObservable();
  }

  setCurrentRoleIfOperativeIsLoaded(isLoaded: boolean) {
    this.loadCurrentRole.next(isLoaded);
  }

  private initCurrentEngagementRole(operative: OperativeInfo) {
    this.originalEngagementRole = new CompanyEngagementHistory(this.engagements?.find(d => d.id === operative.latestEngagementId) as ICompanyEngagementHistory);
    this.tempEngagementRole = new CompanyEngagementHistory(this.originalEngagementRole as ICompanyEngagementHistory);
    this.selectedBusinessUnitId = this.originalEngagementRole.businessUnitId;
    this.selectedOperativeTypeId = this.originalEngagementRole.operativeTypeId;
    this.updateJobTitles(this.originalEngagementRole.operativeTypeId, false); //This will call/update all the other lists down the chain
    this.selectedEmploymentStatusId = this.originalEngagementRole.employmentStatusId;
    this.showRoleBadge = this.tempEngagementRole?.jobTitle?.electricalWorkType !== ElectricalWorkType.NonElectrical;
    this.loadingCurrentEngagement = false;
  }

  private getTrainingRecordsForOperative() {
    this.trainingRecordsService.getTrainingRecordSummariesForOperative(this.operativeId).subscribe(trainingRecords => {
      this.operativeTrainingRecords = trainingRecords;
      //trainingRecords.forEach(trainingRecord => {
      //  this.operativeTrainingRecords.push(trainingRecord as ITrainingRecordSummary);
      //})

      this.totalCPDHours = this.operativeTrainingRecords.filter(record => record.cpdHour > 0).reduce((acc, record) => acc + record.cpdHour, 0);
      this.totalCPDHours = parseFloat(this.totalCPDHours.toFixed(2));

    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
        this.router.navigateByUrl('/dashboard');
      });
    });
  }

  private getTrainingTypesForCompany() {
    this.trainingRecordsService.getTrainingTypesForCompany(this.companyId).subscribe(results => {
      this.trainingRecordTypes.length = 0;
      results.forEach(t => {
        this.trainingRecordTypes.push(t);
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  editOperativeDetails() {
    if (this.opDetailsContainerComponent.isCollapsed) {
      this.opDetailsContainerComponent.panelToggle();
    }
    this.originalOperative = this.operative;
    this.operative = new OperativeInfo(this.originalOperative);

    this.editingOperativeDetails = true;
  }

  cancelEditOperativeDetails() {
    this.editingOperativeDetails = false;
    this.operative = this.originalOperative;
  }

  editCurrentEngagement() {
    if (this.opRiskContainer.isCollapsed) {
      this.opRiskContainer.panelToggle();
    }
    this.originalOperative = this.operative;
    this.operative = new OperativeInfo(this.originalOperative);
    this.editingCurrentEngagement = true;
  }

  cancelEditCurrentEngagement() {
    this.operative = this.originalOperative;
    this.tempEngagementRole = new CompanyEngagementHistory(this.originalEngagementRole as ICompanyEngagementHistory);
    this.selectedBusinessUnitId = this.tempEngagementRole.businessUnitId;
    this.selectedOperativeTypeId = this.tempEngagementRole.operativeTypeId;

    this.updateJobTitles(this.tempEngagementRole.operativeTypeId, false); //This will call/update all the other lists down the chain
    this.editingCurrentEngagement = false;
    this.showJobLevelUpdate = false;
    this.showJobTitleUpdate = false;
    this.showRiskUpdate = false;

  }

  saveNewOperative() {
    this.operative.companyId = this.companyId;
    this.operativesService.createOrUpdateOperative(this.operative).subscribe(operative => {
      this.operative = operative;
      if (this.isNewOperative) {
        this.router.navigate(['operative/', operative.id]);
      }
      this.isNewOperative = false;
      this.editingOperativeDetails = false;
      this.editingCurrentEngagement = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  saveOperativeDetails() {
    if (this.email.valid) {
      this.savingOperativeDetails = true;
      this.operativesService.createOrUpdateOperative(this.operative).subscribe(operative => {
        this.operative = new OperativeInfo(operative);
        this.operativeId = operative.id;
        this.operative.populateRiskMatrixLevel(this.riskMatrix);
        this.disableDatesPriorSelected(this.operative?.latestEngagementFrom);
        this.editingOperativeDetails = false;
        this.savingOperativeDetails = false;
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
    }
  }

  newOperativeImage(imageString: string) {
    this.operative.image = imageString;
  }

  createDocumentObservation(entityDocument: IDocumentSummaryInfo) {
    let observationType: ObservationType;
    let observationFor = '';
    switch (entityDocument.entityType) {
      case DocumentEntityType.company: {
        observationType = ObservationType.CompanyDocument;
        observationFor = 'enterprise document.';
        break;
      }
      case DocumentEntityType.employedPerson: {
        observationType = ObservationType.OperativeDocument;
        observationFor = 'operative document.';
        break;
      }
      case DocumentEntityType.trainingRecord: {
        observationType = ObservationType.TrainingRecordDocument;
        observationFor = 'training record document.';
        break;
      }
    }
    this.selectedDocumentId = entityDocument.documentId;
    this.createOrEditObservation(null, true, 'Add observation to ', observationType, observationFor, false);
  }

  createOrEditObservation(observation?: IObservation, isEditing?: boolean, heading?: string, observationType?: ObservationType, observationFor?: string, showSaveAndUploadButton?: boolean) {
    if (observationFor === undefined || observationFor.length === 0) {
      if (this.operative.getFullName().length !== 0) {
        observationFor = this.operative.getFullName();
      }
    }
    this.observationModalService.createOrEditObservation(observation, heading + observationFor, isEditing, observationType, showSaveAndUploadButton).subscribe(observationModalRef => {
      observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
        if (observationResult !== null) {
          const editedObservation = new Observation({
            id: observationResult.id,
            summaryInfo: observationResult.summaryInfo,
            notesAsHtml: observationResult.notesAsHtml,
            observedBy: observationResult.observedBy,
            observedOn: observationResult.observedOn,
            followUpOn: observationResult.followUpOn,
            observationType: observationResult.observationType
          } as IObservation);
          let entityObservationId = this.getEntityObservationId(editedObservation.id);
          switch (editedObservation.observationType) {
            case ObservationType.Operative: {
              this.observationsLoading = true;
              this.observationsService.createOrUpdateOperativeObservation(editedObservation as IObservation, this.operativeId, this.companyId, entityObservationId).subscribe(operativeObservation => {
                this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, operativeObservation);
                this.operativeObservationsSummary?.forEach(ob => {
                  ob.observationTypeString = ObservationTypeString[ob.observationType];
                });
                this.observationsLoading = false;
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
              break;
            }
            case ObservationType.OperativeDocument:
            case ObservationType.TrainingRecordDocument: {
              this.observationsLoading = true;
              this.observationsService.createOrUpdateDocumentObservation(editedObservation, this.selectedDocumentId, this.companyId, entityObservationId).subscribe(documentObservation => {
                this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, documentObservation);
                this.operativeObservationsSummary?.forEach(ob => {
                  ob.observationTypeString = ObservationTypeString[ob.observationType];
                });
                this.observationsLoading = false;
                this.getOperativeDocuments();
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
              break;
            }
            case ObservationType.TrainingRecord: {
              this.observationsLoading = true;
              this.observationsService.createOrUpdateTrainingRecordObservation(editedObservation, this.selectedTrainingRecordId, this.companyId, entityObservationId).subscribe(trainingRecordObservation => {
                this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, trainingRecordObservation);
                this.operativeObservationsSummary?.forEach(ob => {
                  ob.observationTypeString = ObservationTypeString[ob.observationType];
                });
                this.observationsLoading = false;
                this.getTrainingRecordsForOperative();
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
              break;
            }
          }

          observationModalRef.dynamicDialogRef.close();
        }
      });
      observationModalRef.content.saveObservationDocumentRequested.subscribe(observationResult => {
        if (observationResult !== null) {
          const editedObservation = new Observation({
            id: observationResult.id,
            summaryInfo: observationResult.summaryInfo,
            notesAsHtml: observationResult.notesAsHtml,
            observedBy: observationResult.observedBy,
            observedOn: observationResult.observedOn,
            followUpOn: observationResult.followUpOn,
            observationType: observationResult.observationType
          } as IObservation);
          let entityObservationId = this.getEntityObservationId(editedObservation.id);
          switch (editedObservation.observationType) {
            case ObservationType.Operative: {
              this.observationsLoading = true;
              this.observationsService.createOrUpdateOperativeObservation(editedObservation as IObservation, this.operativeId, this.companyId, entityObservationId).subscribe(operativeObservation => {
                this.savedObservationId = operativeObservation.observationId;
                this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, operativeObservation);
                this.operativeObservationsSummary?.forEach(ob => {
                  ob.observationTypeString = ObservationTypeString[ob.observationType];
                });
                this.observationsLoading = false;
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
              break;
            }
            case ObservationType.OperativeDocument:
            case ObservationType.TrainingRecordDocument: {
              this.observationsLoading = true;
              this.observationsService.createOrUpdateDocumentObservation(editedObservation, this.selectedDocumentId, this.companyId, entityObservationId).subscribe(documentObservation => {
                this.savedObservationId = documentObservation.observationId;
                this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, documentObservation);
                this.operativeObservationsSummary?.forEach(ob => {
                  ob.observationTypeString = ObservationTypeString[ob.observationType];
                });
                this.observationsLoading = false;
                this.getOperativeDocuments();
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
              break;
            }
            case ObservationType.TrainingRecord: {
              this.observationsLoading = true;
              this.observationsService.createOrUpdateTrainingRecordObservation(editedObservation, this.selectedTrainingRecordId, this.companyId, entityObservationId).subscribe(trainingRecordObservation => {
                this.savedObservationId = trainingRecordObservation.observationId;
                this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, trainingRecordObservation);
                this.operativeObservationsSummary?.forEach(ob => {
                  ob.observationTypeString = ObservationTypeString[ob.observationType];
                });
                this.observationsLoading = false;
                this.getTrainingRecordsForOperative();
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
              break;
            }
          }

          observationModalRef.dynamicDialogRef.close();
          this.documentModalService.openDocumentUploaderModal({ documentCreationDate: observationResult.ObservedOn } as IEntityDocumentSummary
            , DocumentEntityType.observation, 'Add new Document for Observation')
            .subscribe(documentModalRef => {
              documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
                documentModalRef.dynamicDialogRef.close();
                this.addingObservationDocuments = true;
                documentUploadRequest.append('OperativeId', this.operative.id);
                documentUploadRequest.append('CompanyId', this.companyId);
                documentUploadRequest.append('ObservationId', this.savedObservationId);

                this.observationDocumentService.createOrUpdateObservationDocument(documentUploadRequest).subscribe(observationDocumentSummary => {
                  this.getOperativeDocuments();
                  this.addingObservationDocuments = false;
                  this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

                }, () => {
                  this.errorHandlingService.showErrorWarning().subscribe(() => {
                    // this.router.navigateByUrl('/dashboard');
                  });
                });
              });
            });
        }
      })
    });

  }

  getEntityObservationId(observationId: string): string {
    let entityObservationId = '00000000-0000-0000-0000-000000000000';
    this.operativeObservationsSummary.forEach(x => {
      if (x.observationId === observationId) {
        switch (x.observationType) {
          case ObservationType.Operative: {
            entityObservationId = x.operativeObservationId;
            break;
          }
          case ObservationType.OperativeDocument:
          case ObservationType.TrainingRecordDocument: {
            entityObservationId = x.documentObservationId;
            break;
          }
          case ObservationType.TrainingRecord: {
            entityObservationId = x.trainingRecordObservationId;
            break;
          }
        }
      }
    });
    return entityObservationId;
  }

  saveCurrentEngagement() {
    this.savingEngagementDetails = true;
    let engagement = new CompanyEngagementHistory({} as ICompanyEngagementHistory);
    engagement = new CompanyEngagementHistory(this.tempEngagementRole as ICompanyEngagementHistory);
    engagement.jobTitle = new JobTitleInfo(this.allJobTitles?.find(d => d?.id === this.tempEngagementRole?.jobTitleId) as IJobTitleInfo);
    engagement.jobLevel = new JobLevelInfo(this.allJobLevels?.find(d => d?.id === this.tempEngagementRole?.jobLevelId) as IJobLevelInfo);
    engagement.risk = new RiskInfo(this.allRisks?.find(d => d?.id === this.tempEngagementRole?.riskId) as IRiskInfo);
    engagement.operativeType = new OperativeTypeInfo(this.allOperativeTypes?.find(d => d?.id === this.tempEngagementRole?.operativeTypeId) as IOperativeTypeInfo);
    engagement.businessUnit = new BusinessUnitInfo(this.allBusinessUnits?.find(d => d?.id === this.tempEngagementRole?.businessUnitId) as IBusinessUnitInfo);

    if (engagement.isValid) {
      this.operativesService.createOrUpdateEngagement(engagement as ICompanyEngagementHistory).subscribe(engagement => {
        this.engagements = this.engagements.filter(s => s.id !== engagement.id);
        this.engagements.push(new CompanyEngagementHistory(engagement));
        this.loadOperative();
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
      this.showJobLevelUpdate = false;
      this.showJobTitleUpdate = false;
      this.showRiskUpdate = false;
    } else {
      this.savingEngagementDetails = false;
    }
  }

  addNewEngagement() {
    const newEngagement = new CompanyEngagementHistory();
    //newEngagement.businessUnitId = this.operative.currentBusinessUnitId;
    newEngagement.jobTitleId = this.tempEngagementRole?.businessUnitId;
    //newEngagement.operativeTypeId = this.operative.currentOperativeTypeId;
    newEngagement.operativeTypeId = this.tempEngagementRole.operativeTypeId;
    //newEngagement.jobTitleId = this.operative.currentJobTitleId;
    newEngagement.jobTitleId = this.tempEngagementRole?.jobTitleId;
    //newEngagement.jobLevelId = this.operative.currentJobLevelId;
    newEngagement.jobLevelId = this.tempEngagementRole?.jobLevelId;
    //newEngagement.riskId = this.operative.currentRiskId;
    newEngagement.riskId = this.tempEngagementRole.riskId;
    newEngagement.companyId = this.companyId;
    newEngagement.operativeId = this.operative.id;
    //newEngagement.businessUnit = new BusinessUnitInfo(this.allBusinessUnits?.find(d => d?.id === this.operative.currentBusinessUnitId) as IBusinessUnitInfo);
    //newEngagement.operativeType = new OperativeTypeInfo(this.allOperativeTypes?.find(d => d?.id === this.operative.currentOperativeTypeId) as IOperativeTypeInfo);
    //newEngagement.jobTitle = new JobTitleInfo(this.allJobTitles?.find(d => d?.id === this.operative.currentJobTitleId) as IJobTitleInfo);
    //newEngagement.jobLevel = new JobLevelInfo(this.allJobLevels?.find(d => d?.id === this.operative.currentJobLevelId) as IJobLevelInfo);
    //newEngagement.risk = new RiskInfo(this.allRisks?.find(d => d?.id === this.operative.currentRiskId) as IRiskInfo);
    newEngagement.businessUnit = new BusinessUnitInfo(this.allBusinessUnits?.find(d => d?.id === this.tempEngagementRole.businessUnitId) as IBusinessUnitInfo);
    newEngagement.operativeType = new OperativeTypeInfo(this.allOperativeTypes?.find(d => d?.id === this.tempEngagementRole.operativeTypeId) as IOperativeTypeInfo);
    newEngagement.jobTitle = new JobTitleInfo(this.allJobTitles?.find(d => d?.id === this.tempEngagementRole.jobTitleId) as IJobTitleInfo);
    newEngagement.jobLevel = new JobLevelInfo(this.allJobLevels?.find(d => d?.id === this.tempEngagementRole.jobLevelId) as IJobLevelInfo);
    newEngagement.risk = new RiskInfo(this.allRisks?.find(d => d?.id === this.tempEngagementRole.riskId) as IRiskInfo);

    this.engagementModalService.openEngagementEditorModal(
      'Add New Role for ' + this.operative.getFullName(),
      this.allJobTitles,
      this.allCompanyJobTitles,
      this.allJobLevels,
      this.allRisks,
      this.allOperativeTypes,
      this.allBusinessUnits,
      this.allEmploymentStatuses,
      true,
      newEngagement).subscribe(modalRef => {
        modalRef.content.cancelEngagementClicked.subscribe(result => {
          this.engagementModalService.engagementModalRef.dynamicDialogRef.close();
        });
        modalRef.content.saveEngagementClicked.subscribe(engagement => {
          this.engagementModalService.engagementModalRef.dynamicDialogRef.close();
          this.savingEngagementDetails = true;
          this.operativesService.createOrUpdateEngagement(engagement).subscribe(engagementResult => {
            this.loadOperative();
            this.savingEngagementDetails = false;
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        });
      });
  }

  addNewTrainingRecord() {
    this.trainingRecordModalService
      .openTrainingRecordEditorModal('Add New Training Record to ' + this.operative.firstName + ' ' + this.operative.lastName,
        this.trainingRecordTypes, true, false).subscribe(trainingRecordModalRef => {
          trainingRecordModalRef.content.saveTrainingRecordClicked.subscribe(trainingRecordResult => {
            if (trainingRecordResult !== null) {
              this.updatingTrainingRecord = true;
              let editedTrainingRecord = new TrainingRecord(trainingRecordResult as ITrainingRecord);
              editedTrainingRecord.operativeId = this.operativeId;
              this.trainingRecordsService.createOrUpdateTrainingRecord(editedTrainingRecord).subscribe(newTrainingRecord => {
                if (newTrainingRecord) {
                  this.getTrainingRecordsForOperative();
                  this.trainingRecordModalService.modalRef.dynamicDialogRef.close();
                  this.updatingTrainingRecord = false;
                }
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
            }
          });
          trainingRecordModalRef.content.saveNewTrainingRecordDocumentRequested.subscribe(trainingRecordResult => {
            if (trainingRecordResult !== null) {
              this.updatingTrainingRecord = true;
              let editedTrainingRecord = new TrainingRecord(trainingRecordResult as ITrainingRecord);
              editedTrainingRecord.operativeId = this.operativeId;
              this.trainingRecordsService.createOrUpdateTrainingRecord(editedTrainingRecord).subscribe(newTrainingRecord => {
                if (newTrainingRecord) {
                  this.trainingRecordModalService.modalRef.dynamicDialogRef.close();
                  this.updatingTrainingRecord = false;
                  this.addTrainingRecordDocument(newTrainingRecord);
                }
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
            }
          });


          trainingRecordModalRef.content.saveNewTrainingRecordTypeRequested.subscribe(newTrainingType => {
            if (newTrainingType !== null) {
              this.updatingTrainingRecord = true;
              newTrainingType.companyId = this.companyId;
              this.trainingRecordsService.createOrUpdateCompanyTrainingType(newTrainingType).subscribe(trainingType => {
                if (trainingType) {
                  this.getTrainingTypesForCompany();
                  this.trainingTypeService.setSelectedTrainingTypeId(trainingType.id);
                  this.trainingTypeService.setSelectedTrainingTypeValidTo(trainingType.validTo);
                  this.updatingTrainingRecord = false;
                }
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });
            }
          });
        });
  }

  downloadOperativeDocument(operativeDocuments: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(operativeDocuments, true);
  }

  openOperativeDocument(operativeDocuments: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(operativeDocuments);
  }

  deleteOperativeDocumentClick(operativeDocument: IEntityDocumentSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to remove this document?',
      'Remove ' + operativeDocument.originalFilename, new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.addingOperativeDocuments = true;
            this.deleteOperativeDocument(operativeDocument);

          }
        }
      });
  }

  deleteOperativeDocument(operativeDocument: IEntityDocumentSummary) {
    this.operativeDocumentService.deleteOperativeDocument(this.companyId, operativeDocument.documentId).subscribe(
      result => {
        if (result) {
          const documentIndex = this.operativeDocuments.findIndex(c => c.documentId === operativeDocument.documentId);
          this.operativeDocuments.splice(documentIndex, 1);
          this.addingOperativeDocuments = false;
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
        }
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
          // this.router.navigateByUrl('/dashboard');
        });
      });
  }

  editOperativeDocument(operativeDocumentSummary: IEntityDocumentSummary) {
    this.documentModalService.openDocumentUploaderModal(operativeDocumentSummary, DocumentEntityType.employedPerson, 'Edit Operative Document')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close()
          documentUploadRequest.append('OperativeId', this.operative.id);
          this.operativeDocumentService.createOrUpdateOperativeDocument(documentUploadRequest)
            .subscribe(updatedOperativeDocumentsSummary => {
              this.getOperativeDocuments();
              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
                // this.router.navigateByUrl('/dashboard');
              });
            });
        });
      });
  }

  addTrainingRecordDocument(trainingRecord: ITrainingRecord) {
    this.documentModalService.openDocumentUploaderModal({ documentCreationDate: trainingRecord?.achievedOn } as IEntityDocumentSummary
      , DocumentEntityType.trainingRecord, 'Add new Document to Training Record' + ' ' + trainingRecord?.trainingType?.name)
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close()
          documentUploadRequest.append('TrainingRecordId', trainingRecord?.id);
          documentUploadRequest.append('CompanyId', this.companyId);
          this.trainingRecordDocumentService.createOrUpdateTrainingRecordDocument(documentUploadRequest)
            .subscribe(trainingRecordSummary => {
              this.getTrainingRecordsForOperative();
              this.getOperativeDocuments();
              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
            }, () => {
              this.errorHandlingService.showErrorWarning()?.subscribe(() => {
              });
            });

        });
        documentModalRef.content.cancelClicked?.subscribe(() => {
          this.getTrainingRecordsForOperative();
        });
      });
  }

  addOperativeDocument() {
    this.documentModalService.openDocumentUploaderModal(null, DocumentEntityType.employedPerson, 'Add Document for ' + this.operative?.fullName)
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close();
          this.addingOperativeDocuments = true;
          documentUploadRequest.append('OperativeId', this.operative.id);
          documentUploadRequest.append('CompanyId', this.companyId);
          this.operativeDocumentService.createOrUpdateOperativeDocument(documentUploadRequest).subscribe(operativeDocumentSummary => {
            this.getOperativeDocuments();
            this.addingOperativeDocuments = false;
            this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
              // this.router.navigateByUrl('/dashboard');
            });
          });
        });
      });
  }

  setTrainingRecordId(trainingRecordId: string) {
    this.selectedTrainingRecordId = trainingRecordId;
  }

  setSelectedDocumentId(documentId: string) {
    this.selectedDocumentId = documentId;
  }

  viewOperativeDocument(operativeDocument: IEntityDocumentSummary) {
    this.router.navigate(['operative-document', operativeDocument.documentId]);

  }

  openRiskHelp() {
    const basicLevels: JobLevelInfo[] = [];
    this.allJobLevels.forEach(l => {
      let jobLevelInfo = new JobLevelInfo(l);
      jobLevelInfo.name = l.basicName;
      basicLevels.push(jobLevelInfo);
    });
    const basicRisks: RiskInfo[] = [];
    this.allRisks.forEach(r => {
      let riskInfo = new RiskInfo(r);
      riskInfo.name = r.basicName;
      basicRisks.push(riskInfo);
    });

    this.riskHelpModalService.openRiskHelpModal('Help', this.riskMatrix, basicRisks, basicLevels, [this.operative], null, '', this.loggedInUser?.companyName, this.isQsRole);
  }

  addOperative() {

    const newOperative = new OperativeInfo();
    this.populateBreadcrumbs(false);
    newOperative.companyId = this.companyId;
    this.operativeModalService.openOperativeEditorModal(
      newOperative,
      'Add a New Operative',
      this.allJobTitles,
      this.allCompanyJobTitles,
      this.allJobLevels,
      this.allRisks,
      this.allEmploymentStatuses,
      this.allOperativeTypes,
      this.allBusinessUnits,
      true).subscribe(modalRef => {
        modalRef.content.saveOperativeRequested.subscribe(operative => {
          if (operative) {
            this.populateBreadcrumbs(true, operative);
            this.operativesService.createOrUpdateOperative(operative).subscribe(operative => {
              if (operative) {
                this.router.navigate(['/operative/' + operative.id]);
              }
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
          }
        });
        modalRef.content.cancelRequested.subscribe(result => {
          this.router.navigate(['/operatives']);
        });
      });
  }

  deleteTrainingRecordClick(trainingRecord: ITrainingRecord) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to remove this training record?',
      'Remove Training Record', new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.trainingRecordsService.deleteTrainingRecord(trainingRecord).subscribe(result => {
              if (result) {
                this.getTrainingRecordsForOperative();
              }
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
                // this.router.navigateByUrl('/dashboard');
              });
            });
          }
        }
      });
  }

  getOperativeDocuments(includeExpired: boolean = false) {
    this.operativeDocumentService.getAllDocumentSummariesForOperative(this.companyId, includeExpired, this.operativeId).subscribe(operativeDocumentSummaries => {
      this.operativeDocuments = [];
      operativeDocumentSummaries?.forEach(doc => this.operativeDocuments.push(doc));
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
        // this.router.navigateByUrl('/dashboard');
      });
    });
  }

  loadOperative() {
    this.getOperativeById();
    this.getOperativeDocuments();
    this.listDataService.getRiskMatrix().subscribe(result => {
      this.riskMatrix = result;
      this.operative.populateRiskMatrixLevel(this.riskMatrix);
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.observationsService.getOperativeObservations(this.operativeId, this.companyId).subscribe(operativeObservations => {
      operativeObservations?.forEach(ob => {
        ob.observationTypeString = ObservationTypeString[ob.observationType];
      });
      this.operativeObservationsSummary = operativeObservations;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
    this.operativesService.getCompanyEngagementsFor(this.operativeId, this.companyId).subscribe(companyEngagements => {
      let engagementsLoaded = false;
      if (companyEngagements) {
        engagementsLoaded = true;
        this.engagements = new Array<CompanyEngagementHistory>();
        companyEngagements.forEach(item => {
          if (item.operativeTypeId == "4eff2451-6793-4590-82c1-fc189dc47859") {
            var companyJobtitle = this.allCompanyJobTitles.find(x => x.id === item.jobTitleId)?.name;
            item.jobTitle = { name: companyJobtitle } as IJobTitleInfo;
          }
          this.engagements.push(new CompanyEngagementHistory(item as ICompanyEngagementHistory));
        })
        this.engagements.forEach(eng => { eng.supervisionString = eng.jobTitle?.name === 'Qualified Supervisor' ? 'QS' : DegreeOfSupervisionString[eng.riskMatrixLevel]; })
      }
      this.loadCurrentRoleSubscription = this.getCurrentRoleIfOperativeIsLoaded().subscribe(value => {
        if (value && engagementsLoaded) {
          this.initCurrentEngagementRole(this.operative);
        }
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.getTrainingRecordsForOperative();
    // Update alerts counts after updating operative.. not sure on this..
    this.alertsService.getSupervisionAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  }

  deleteRoleHistoryClick(roleHistory: ICompanyEngagementHistory) {
    this.confirmProcessService.openConfirmProcessModal('<p>Are you SURE you want to remove this role history?</p><p>You may need to adjust the remaining role histories if the operative the operative\'s is still working with the company.</p>',
      'Remove Role History', new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.operativesService.deleteCompanyEngagement(roleHistory).subscribe(result => {
              this.loadOperative();
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
                // this.router.navigateByUrl('/dashboard');
              });
            });
          }
        }
      });
  }

  openOperativeDetailsHelp() {
    this.helpService.openHelpModal(HelpConsts.OperativeDetails);
  }

  createTrainingRecordObservation(trainingRecordId: string) {
    this.setTrainingRecordId(trainingRecordId);
    this.createOrEditObservation(null, true, 'Add Observation to', ObservationType.TrainingRecord, ' the training record', true);
  }

  updateBusinessUnit(businessUnitId: string) {
    this.tempEngagementRole.businessUnitId = businessUnitId;//ensure correct businessUnitId
  }

  updateJobTitles(operativeTypeId: string, showUpdateAlert: boolean) {
    this.tempEngagementRole.operativeTypeId = operativeTypeId;//ensure correct operative typeid

    if (this.tempEngagementRole.operativeTypeId == "4eff2451-6793-4590-82c1-fc189dc47859") {

      this.selectedJobTitleId = this.allCompanyJobTitles.find(f => f.id == this.tempEngagementRole.jobTitleId)?.id;
      if (!this.selectedJobTitleId) { //job title not found in list so default to the first in the list
        this.selectedJobTitleId = this.allCompanyJobTitles[0].id;
        this.tempEngagementRole.jobTitleId = this.selectedJobTitleId;
      }
    }
    else {
      this.filteredJobTitles = this.allJobTitles.filter(f => f.operativeTypeId == this.tempEngagementRole.operativeTypeId);
      this.selectedJobTitleId = this.filteredJobTitles.find(f => f.id === this.tempEngagementRole.jobTitleId)?.id;

      if (!this.selectedJobTitleId) { //job title not found in list so default to the first in the list
        this.selectedJobTitleId = this.filteredJobTitles[0].id;
        this.tempEngagementRole.jobTitleId = this.selectedJobTitleId;
      }
    }
    //Complete other tasks
    this.showJobTitleUpdate = showUpdateAlert;
    this.updateJobLevel(this.tempEngagementRole.jobTitleId, showUpdateAlert);
  }

  updateJobLevel(jobTitleId: string, showUpdateAlert: boolean) {
    this.tempEngagementRole.jobTitleId = jobTitleId;
    this.showJobLevelUpdate = showUpdateAlert;
    if (this.tempEngagementRole.operativeTypeId == "4eff2451-6793-4590-82c1-fc189dc47859") {
      this.selectedCompanyJobTitleId = this.allCompanyJobTitles.find(x => x.id === this.tempEngagementRole.jobTitleId)?.id;
      this.isQsRole = false;
      this.isNonElectricalJobRole = true;
      this.defaultJobJevelId = this.allCompanyJobTitles.find(x => x.id === this.tempEngagementRole.jobTitleId)?.defaultJobLevelId;
    }
    else {
      this.isQsRole = this.filteredJobTitles.find(d => d.id === jobTitleId)?.electricalWorkType == ElectricalWorkType.QualifiedSupervisor;
      this.isNonElectricalJobRole = this.filteredJobTitles.find(d => d.id === jobTitleId)?.electricalWorkType == ElectricalWorkType.NonElectrical;
      this.defaultJobJevelId = this.filteredJobTitles.find(d => d.id === jobTitleId)?.defaultJobLevelId;
    }

    if (this.isNonElectricalJobRole) {
      this.filteredJobLevels = this.allJobLevels.filter(f => f.index === 0);
    }
    else if (this.isQsRole) {
      this.filteredJobLevels = this.allJobLevels.filter(f => f.id == this.defaultJobJevelId);
    }
    else {
      this.filteredJobLevels = this.allJobLevels.filter(f => f.operativeTypeId == this.tempEngagementRole.operativeTypeId).sort((a, b) => a.index - b.index);
    }
    this.selectedJobLevelId = this.filteredJobLevels.find(x => x.id === this.tempEngagementRole.jobLevelId)?.id;

    //job level not found so set to default value for the selected job title
    if (!this.selectedJobLevelId) {
      this.selectedJobLevelId = this.filteredJobLevels.find(x => x.id === this.defaultJobJevelId)?.id;
      this.tempEngagementRole.jobLevelId = this.selectedJobLevelId;
    }
    
    this.updateRisk(this.tempEngagementRole.jobLevelId, showUpdateAlert);
  }

  updateRisk(jobLevelId: string, showUpdateAlert: boolean) {
    this.tempEngagementRole.jobLevelId = jobLevelId;
    this.showRiskUpdate = showUpdateAlert;
    if (this.isNonElectricalJobRole) {
      this.filteredRisks = this.allRisks.filter(f => f.index === 0);
    }
    else {
      this.filteredRisks = this.allRisks.filter(f => f.operativeTypeId == this.tempEngagementRole.operativeTypeId).sort((a, b) => a.index - b.index);
    }
    this.selectedRiskId = this.filteredRisks.find(x => x.id === this.tempEngagementRole.riskId)?.id;
    //risk not found so set to first value in filtered list
    if (!this.selectedRiskId) {
      this.selectedRiskId = this.filteredRisks[0].id;
      this.tempEngagementRole.riskId = this.selectedRiskId;
    }
    
  }


  updateRiskItself(changedRiskId: string) {
    this.tempEngagementRole.riskId = changedRiskId;
  }
}
